// extracted by mini-css-extract-plugin
export default {"links":"loginlinks_links__-JsyD","link":"loginlinks_link__C6qE9","errorBlock":"loginlinks_errorBlock__RN5Rd","errorText":"loginlinks_errorText__8ZZJh"};